<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0249 4.94141C12.0249 4.94141 13.3333 8.74975 17.0833 9.99974C13.3333 11.2497 12.0249 15.0581 12.0249 15.0581" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.91665 10H16.9417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
